import { createRouter, createWebHashHistory } from 'vue-router'
import resources from "@/resources";
import store from "@/store";

const router = createRouter({
	scrollBehavior()
	{
		// always scroll to top
		return { top: 0 }
	},
	history: createWebHashHistory(),
	routes: [
		{
			path: '/',
			component: () => import('@/views/layout/aniresan/Layout.vue'),
			redirect: '/home',
			meta: {
				res: 'page.aniresan',
			},
			children: [
				{
					path: '/home',
					component: () => import("@/views/home/Index.vue"),
					meta: {
						res: 'page.home',
					}
				},

				{
					path: '/page/:name',
					component: () => import("@/views/page/Page.vue"),
					meta: {
						res: 'page.aniresan',
					}
				}

				,
				{
					path: '/representation',
					component: () => import("@/views/page/Representation.vue"),
					meta: {
						res: 'page.aniresan',
					}
				},
				{
					path: '/complaint',
					component: () => import("@/views/page/Complaint.vue"),
					meta: {
						res: 'page.aniresan',
					},

				},
				{
					path: '/page/faq',
					component: () => import("@/views/page/Faq.vue"),
					meta: {
						res: 'page.faq',
					},

				},
				{
					path: '/page/Allnews',
					component: () => import("@/views/page/Allnews.vue"),
					meta: {
						res: 'page.Allnews',
					},

				},
				{
					path: '/register',
					component: () => import("@/views/register/register.vue"),
					meta: {
						res: 'page.aniresan',
					},

				},
         
				{
					path: '/page/tracking-register',
					component: () => import("@/views/page/TrackingRegister.vue"),
					meta: {
						res: 'page.aniresan',
					},
				},
           



			]
		},

		{
			path: "/:catchAll(.*)",
			component: () => import("@/views/NotFound"),
			meta: {
				res: 'page.notFound',
			},
		},

	]
})


router.beforeEach((to, from, next) =>
{
	//store.commit('setBreadcrumbs', to.matched);

	document.title =
		resources(to.meta.res) + ' | ' +
		resources('global.applicationName');


	if (to.matched.some(record => record.meta.requiresAuth))
	{
		if (store.state.person.token.accessToken == undefined)
		{
			next({
				path: "/auth",
				query: { redirect: to.fullPath }
			});

			return;
		}
	}

	next();
});


export default router
